import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";

const EnterChannelNameURL = ({
  channelPayLoad,
  setChannelPayLoad,
  isValidUrl,
  apiErrors = [],
}) => {
  const handleChange = (key) => (e) => {
    const value = e.target.value?.replace(/\s+/g, " ").trimStart();

    if (
      key === "channelName" &&
      value.length > GlobalConfiguration?.inputValidationLength
    ) {
      return;
    }

    setChannelPayLoad((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const hasUrlText = Boolean(channelPayLoad?.channelUrl?.trim());
  const hasError =
    Array.isArray(apiErrors) &&
    apiErrors.length > GlobalConfiguration?.lengthCheckZero;
  const isUrlInvalid = (hasUrlText && !isValidUrl) || hasError;

  const getUrlVariant = () => {
    if (hasError) return "error";
    if (!hasUrlText) return "default";
    return isValidUrl ? "verified" : "error";
  };

  const getUrlAdornment = () => {
    if (hasError) return ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;
    if (!hasUrlText) return "";
    return isValidUrl ? "" : ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;
  };

  return (
    <div className="flex flex-col global-card-create gap-gap-md">
      <p className="text-text-primary font-semibold text-base">
        {TEXT?.CHANNEL} {TEXT?.DETAILS}
      </p>
      <div className="flex flex-col gap-gap-xs">
        <TextInputField
          variant={getUrlVariant()}
          placeholder={`${TEXT?.CHANNEL} ${TEXT?.URL.toUpperCase()}`}
          bgColor="var(--primary-card)"
          fgColor="var(--text-primary)"
          value={channelPayLoad.channelUrl}
          name="channel_url"
          onInput={handleChange("channelUrl")}
          isFullWidth={true}
          adornment={getUrlAdornment()}
        />

        {isUrlInvalid && (
          <div>
            <p className="text-failed font-normal text-font-xs">
              {hasError ? apiErrors[0] : TEXT?.INVALID_URL}
            </p>
          </div>
        )}
      </div>

      <TextInputField
        variant={"default"}
        placeholder={`${TEXT?.CHANNEL} ${TEXT?.NAME.toLowerCase()}`}
        bgColor="var(--primary-card)"
        fgColor="var(--text-primary)"
        value={channelPayLoad.channelName}
        name="channel_name"
        onInput={handleChange("channelName")}
        isFullWidth={true}
        adornment={""}
      />
    </div>
  );
};

export default EnterChannelNameURL;
